<template>
  <div style="background-color: white">
    <el-row style="padding-top: 10px">
      <el-col :span="24">
        <el-button size="small" class="btn" type="primary" v-if="show.qr" @click="handleCreate">报废确认</el-button>
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float:right!important">
          <el-form-item label="筛选单位">
            <el-cascader
            v-model="deviceInfo.companyCode" 
              :options="companyTree"
              :show-all-levels="false"
              :props="props"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker v-model="deviceInfo.date" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input v-model="deviceInfo.content" auto-complete="off" placeholder="请输入搜索内容"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="findAllClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="scrapData" tooltip-effect="dark"
          style="width: 100%; text-align: center" stripe>
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column :label="lable.index" type="index"  show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="id" :label="lable.id" width="170">
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link :underline="false" @click="onClick(scope.row)" style="color: #4095e5; text-decoration: none">
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="glbh" :label="lable.glbh" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="zcmc" :label="lable.zcmc" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="ssdw" :label="lable.ssdw" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="scrapTime" :label="lable.scrapTime" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="scrapReson" :label="lable.scrapReson" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="method" :label="lable.method" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="statue" :label="lable.statue" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.statue == '2'" style="color: gray">待确认</span>
            </template>
          </el-table-column>
          <el-table-column :label="lable.cz" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button @click="selectClick(scope.row)" type="text" size="small">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination v-if="scrapData.length > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>
    </el-row>
    <!--------------------------------------------------------------------报废确认--------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" title="报废确认"
      style="width: 100% !important; margin-left: 80px">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 90%; margin-left: 5%">
        <el-row>
          <el-col :span="12">
            <el-form-item label="资产编号" prop="correctAnswer" style="width: 90%">
              <el-input v-model="questionForm.deviceId" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.zcmc">
              <el-input v-model="questionForm.zcmc" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="资产型号" style="width: 90%">
              <el-input v-model="questionForm.sbxh" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出厂日期">
              <el-input v-model="questionForm.ccrq" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width: 90%">
              <el-input v-model="questionForm.userName" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请日期">
              <el-input v-model="questionForm.sqrq" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.companyName" style="width: 90%">
              <el-input v-model="questionForm.companyName" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核结果">
              <el-input v-model="questionForm.result" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.scrapReson">
          <el-input v-model="questionForm.scrapReson" :readonly="true" />
        </el-form-item>
        <el-form-item label="审核意见">
          <el-input type="textarea" :rows="2" :readonly="true" v-model="questionForm.ssyj" />
        </el-form-item>
        <!-- <el-form-item label="确认结果">
          <el-radio-group v-model="questionForm.qr">
            <el-radio label="0">报废</el-radio>
            <el-radio label="1">未报废</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item :label="lable.method">
          <el-input :placeholder="'请输入' + lable.method" v-model="questionForm.method" />
        </el-form-item>
        <el-form-item label="处置日期">
          <el-date-picker v-model="questionForm.handleTime" style="width: 100%" width="100%" type="date"
            value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table :data="fileData" :border="false" style="width: 100%; text-align: center" size="mini"
            max-height="235px" :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index"  show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot-scope="scope">
                <el-button @click="yulan(scope.row)" type="text" size="small">预览</el-button>
                <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px" type="primary" @click="notarize" v-preventReClick>确定</el-button>
        <el-button style="margin-left: 10px" type="danger" @click="noNotarize" v-preventReClick>驳回</el-button>

        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!--------------------------------------------------------------------报废详情--------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible1" :close-on-click-modal="false"
      :close-on-press-escape="false" title="报废详情"
      style="width: 80% !important; margin-left: 400px">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 90%; margin-left: 5%">
        <el-row>
          <el-col :span="12">
            <el-form-item label="资产编号" style="width: 90%">
              <el-input v-model="questionForm.deviceId" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.zcmc">
              <el-input v-model="questionForm.zcmc" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="资产型号" style="width: 90%">
              <el-input v-model="questionForm.sbxh" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出厂日期">
              <el-input v-model="questionForm.ccrq" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width: 90%">
              <el-input v-model="questionForm.userName" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请日期">
              <el-input v-model="questionForm.sqrq" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.companyName" style="width: 90%">
              <el-input placeholder="" v-model="questionForm.companyName" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核结果">
              <el-input v-model="questionForm.result" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.scrapReson">
          <el-input v-model="questionForm.scrapReson" :readonly="true" />
        </el-form-item>
        <el-form-item label="审核意见">
          <el-input type="textarea" :rows="2" :readonly="true" v-model="questionForm.ssyj" />
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table :data="fileData" :border="false" style="width: 100%; text-align: center" size="mini"
            max-height="235px" :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot-scope="scope">
                <el-button @click="yulan(scope.row)" type="text" size="small">预览</el-button>
                <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px" @click="dialogFormVisible1 = false" type="primary"
          v-preventReClick>确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px" width="63%">
      <FilePreview ref="filePreview" />
    </el-dialog>
  </div>
</template>
<script>
import { findAllDeviceScrap, findByIdFile, notarizeScrap, findByModule,findByUserIdCompanyTree } from "../../api/api";
import FilePreview from '../../components/preview/FilePreview.vue'

export default {
  name: "Confirmation",
  components: {
    "FilePreview": FilePreview,
  },
  data() {
    return {
      companyTree:[],
      props: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
      },
      deviceInfo: {
        date: [],
        content: "",
        state: ""
      },
      lable: {},
      show: {
        qr: false
      },
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      scrapData: [],
      fileData: [],
      multipleTable: [],
      dialogFormVisible: false,
      dialogFormVisible1: false,
      questionForm: {},
      docxdialog: false,
      previewTitle: '',
    };
  },

  methods: {
    downloading(scop) {
      // debugger
      this.downloadUtil.downloadFile(scop.path, scop.name);
    },
    yulan(row) {
      if (row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpg' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'png' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpeg') {
        this.previewTitle = "图片预览"
      } else {
        this.previewTitle = "文件预览"
      }
      this.docxdialog = true
      this.$nextTick(() => {
        this.$refs.filePreview.showView(row.path)
      })
      // this.downloadUtil.preview(row.path)
    },
    onClick(row) {
      if (this.show.qr) {
        this.questionForm = {};
        this.questionForm = row;
        this.findByIdfile(row.id);
        this.dialogFormVisible = true;
      } else {
        this.$message.warning("您不具有该权限")
      }

    },
    updateClick(row) {
      this.questionForm = {
        questionContent: "",
        correctAnswer: "",
        otherAnswer1: "",
        otherAnswer2: "",
        otherAnswer3: "",
        userGrades: [],
        questionCategory: ""
      };
      this.dialogFormVisible = true;
    },
    handleClick(row) {
    },
    handleCreate() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.error("只能选择一个设备"); // .....失败信息
      } else if (currentSelect.length == 1) {
        this.questionForm = {};
        this.questionForm = currentSelect[0];
        this.$set(this.questionForm, `scrapTime`, this.timeUtil.timeFormat(new Date()));
        this.dialogFormVisible = true;
        this.findByIdfile(currentSelect[0].id);
      } else {
        this.$message.error("请选择设备"); // .....失败信息
      }
    },

    selectClick(row) {
      this.questionForm = {};
      this.questionForm = row;
      this.dialogFormVisible1 = true;
    },
    noNotarize() {
      this.questionForm.qr = 1;
      var userinfo = JSON.parse(localStorage.getItem("user"))
      this.questionForm.userId = userinfo.userId
      notarizeScrap(this.questionForm).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.$message({
            message: "驳回成功",
            type: "success"
          });
          this.findAll();
          this.dialogFormVisible = false;
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    notarize() {
      this.questionForm.qr = 0;
      var userinfo = JSON.parse(localStorage.getItem("user"))
      this.questionForm.userId = userinfo.userId
      notarizeScrap(this.questionForm).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.$message({
            message: "确认成功",
            type: "success"
          });
          this.findAll();
          this.dialogFormVisible = false;
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },

    //根据id查找文件
    findByIdfile(id) {
      findByIdFile(id).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.fileData = data;
          // debugger
        }
      });
    },
    findAllClick(){
      this.pageIndex=1;
      this.findAll();
    },
    //查找所有维保信息
    findAll() {
      var userinfo = JSON.parse(localStorage.getItem("user"))

      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        state: 2,
        userId: userinfo.userId,
        companyCode:null
      };
      if(this.deviceInfo.companyCode!=null){
        map.companyCode=this.deviceInfo.companyCode[this.deviceInfo.companyCode.length-1] 
      }
      findAllDeviceScrap(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) { this.data = [] } else { this.data = data; }
          this.scrapData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = this.data.length;
        }
      });
    },
    //分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.scrapData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.scrapData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    findLable() {
      findByModule("报废管理").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
    getCompanyTree() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var  companyCode='';
      if (userinfo.userRole == 1 || (userinfo.fjqx != null && (userinfo.fjqx.indexOf ("3")!=-1||userinfo.fjqx.indexOf ("4")!=-1))) {
        companyCode="-1"
      }else{
        companyCode=userinfo.companyCode
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.companyTree = this.getTreeData(data);
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].zcompany);
        }
      }
      return data;
    },
  },
  created() {
    this.getCompanyTree();
    this.findLable();
    this.findAll();
    var userinfo = JSON.parse(localStorage.getItem("user"))
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "112") {
        this.show.qr = true;
      }
    })
  }
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/scrap/Confirmation.vue